module.exports = __webpack_public_path__ + "media/images/flags/4x3/rus-05234af27207253323b725b97d961994.svg";